import { createApiCall } from 'services/api';
import { transformConversightStatus } from './transformations';
import { ConversightStatus } from './types';

export const fetchInsightsStatus = async (): Promise<ConversightStatus> => {
  const res = await createApiCall(
    {
      hostname: `${process.env.REACT_APP_IDENTITY_URL}`,
      path: `/conversight/status`,
      method: 'GET',
    },
    {
      getMessage: {
        error: (error: any) => {
          if (error.response?.data?.message) {
            return `${error.response.data.message}`;
          }
          return 'Failed to fetch ConverSight status. Please try again later.';
        },
      },
    }
  )();

  if (!res?.data?.data) {
    console.error('Invalid response format from ConverSight status API');
  }

  return transformConversightStatus(res?.data?.data);
};
